document.addEventListener('DOMContentLoaded', function () {

  /* ---------- Scroll gauge ---------- */
  var fill = document.getElementById('scroll-gauge-fill');
  function updateGauge() {
    if (!fill) return;
    var h = document.documentElement;
    var scrolled = h.scrollTop;
    var height = h.scrollHeight - h.clientHeight;
    var pct = height > 0 ? (scrolled / height) * 100 : 0;
    fill.style.width = pct + '%';
  }
  document.addEventListener('scroll', updateGauge, { passive: true });
  updateGauge();

  /* ---------- Variant swatches ---------- */
  document.querySelectorAll('.hero__form').forEach(function (form) {
    var swatches = form.querySelectorAll('.swatch');
    var variantIdInput = form.querySelector('#hero-variant-id');
    var selections = {};

    swatches.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var group = btn.closest('.option-row').querySelectorAll('.swatch');
        group.forEach(function (b) { b.classList.remove('is-selected'); });
        btn.classList.add('is-selected');
        selections[btn.dataset.optionIndex] = btn.dataset.value;
      });
    });
  });

  /* ---------- Quantity stepper ---------- */
  document.querySelectorAll('.qty').forEach(function (qty) {
    var input = qty.querySelector('.qty__input');
    qty.querySelectorAll('.qty__btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var val = parseInt(input.value || '1', 10);
        val = btn.dataset.qty === 'plus' ? val + 1 : Math.max(1, val - 1);
        input.value = val;
      });
    });
  });

  /* ---------- Cart drawer ---------- */
  var drawer = document.getElementById('cart-drawer');
  var overlay = document.getElementById('cart-drawer-overlay');
  var closeBtn = document.getElementById('cart-drawer-close');
  var openBtn = document.getElementById('cart-open-btn');
  var body = document.getElementById('cart-drawer-body');
  var subtotalEl = document.getElementById('cart-drawer-subtotal');
  var countEl = document.getElementById('cart-count');

  function moneyFormat(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  }

  function renderCart(cart) {
    if (!body) return;
    if (!cart.items.length) {
      body.innerHTML = '<p class="cart-drawer__empty">Tu carrito está vacío todavía.</p>';
    } else {
      body.innerHTML = cart.items.map(function (item) {
        return '<div class="cart-drawer-line">' +
          (item.image ? '<img src="' + item.image + '" alt="' + item.title + '">' : '') +
          '<div><p class="cart-drawer-line__title">' + item.product_title + '</p>' +
          '<span class="cart-drawer-line__meta">' + item.quantity + ' × ' + moneyFormat(item.price) + '</span></div>' +
          '</div>';
      }).join('');
    }
    if (subtotalEl) subtotalEl.textContent = moneyFormat(cart.total_price);
    if (countEl) countEl.textContent = cart.item_count;
  }

  function fetchCart() {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(renderCart).catch(function () {});
  }

  function openDrawer() {
    if (!drawer) return;
    drawer.setAttribute('aria-hidden', 'false');
    fetchCart();
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.setAttribute('aria-hidden', 'true');
  }

  if (openBtn) openBtn.addEventListener('click', openDrawer);
  if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
  if (overlay) overlay.addEventListener('click', closeDrawer);

  /* ---------- Add to cart via AJAX ---------- */
  document.querySelectorAll('.hero__form').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var formData = new FormData(form);
      fetch('/cart/add.js', { method: 'POST', body: formData, headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function () { openDrawer(); })
        .catch(function () {
          form.submit();
        });
    });
  });

  if (drawer) fetchCart();

  /* ---------- Cuenta atrás de la oferta ---------- */
  document.querySelectorAll('[data-offer-timer]').forEach(function (timer) {
    var hoursSetting = parseInt(timer.dataset.hours || '24', 10);
    var storageKey = 'offerDeadline';
    var deadline = sessionStorage.getItem(storageKey);
    if (!deadline) {
      deadline = Date.now() + hoursSetting * 60 * 60 * 1000;
      sessionStorage.setItem(storageKey, deadline);
    }
    deadline = parseInt(deadline, 10);

    var hEl = timer.querySelector('[data-h]');
    var mEl = timer.querySelector('[data-m]');
    var sEl = timer.querySelector('[data-s]');

    function pad(n) { return n < 10 ? '0' + n : '' + n; }

    function tick() {
      var diff = deadline - Date.now();
      if (diff <= 0) {
        deadline = Date.now() + hoursSetting * 60 * 60 * 1000;
        sessionStorage.setItem(storageKey, deadline);
        diff = deadline - Date.now();
      }
      var h = Math.floor(diff / 3600000);
      var m = Math.floor((diff % 3600000) / 60000);
      var s = Math.floor((diff % 60000) / 1000);
      if (hEl) hEl.textContent = pad(h);
      if (mEl) mEl.textContent = pad(m);
      if (sEl) sEl.textContent = pad(s);
    }
    tick();
    setInterval(tick, 1000);
  });

  /* ---------- Popup de newsletter (10% dto) ---------- */
  var popup = document.getElementById('newsletter-popup');
  if (popup) {
    var popupClose = popup.querySelector('.popup-card__close');
    var popupOverlayClick = function (e) { if (e.target === popup) hidePopup(); };
    var dismissedKey = 'newsletterPopupDismissed';

    function showPopup() { popup.classList.add('is-open'); }
    function hidePopup() {
      popup.classList.remove('is-open');
      try { localStorage.setItem(dismissedKey, '1'); } catch (e) {}
    }

    var alreadyDismissed = false;
    try { alreadyDismissed = localStorage.getItem(dismissedKey) === '1'; } catch (e) {}

    if (!alreadyDismissed) {
      setTimeout(showPopup, 8000);
    }

    if (popupClose) popupClose.addEventListener('click', hidePopup);
    popup.addEventListener('click', popupOverlayClick);

    var popupForm = popup.querySelector('form');
    if (popupForm) {
      popupForm.addEventListener('submit', function () {
        try { localStorage.setItem(dismissedKey, '1'); } catch (e) {}
      });
    }
  }
});
